import styled from 'styled-components';

export const FeeItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: space-between;
  width: 100%;
  position: relative;

  &:has(.Tooltip-tip) {
    z-index: 1000;
  }
`;

export const FeeItemTitle = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-start;
  flex: 1;

  /* Align checkbox with the first line of text */
  label {
    padding-top: 2px;
  }
`;

export const FeeItemContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 8px;
`;

export const FeeItemDisclaimer = styled.div<{ hasCheckbox?: boolean }>`
  font-size: small;
  color: gray;
  margin-left: ${({ hasCheckbox }) => (hasCheckbox ? '32px' : '0')};
`;

export const PlusMinusInputWrapper = styled.div<{ hasCheckbox?: boolean }>`
  margin-left: ${({ hasCheckbox }) => (hasCheckbox ? '31px' : '0')};
  margin-top: 4px;
`;
